// Design Ref: §3.1 — Sibling Store mirroring announcementStore pattern
// 인플라이트 가드: 동시 호출은 단일 요청으로 합쳐서 race condition + 중복 부하 제거
import { writable } from 'svelte/store';
import { browser } from '$app/environment';
import { api } from '$lib/utils/api.js';

export const hasUnread = writable(false);

let inflight = null;

export async function checkUnread() {
	if (!browser) return;
	if (inflight) return inflight;
	inflight = api.get('/api/inquiries/unread-check/');
	try {
		const result = await inflight;
		if (result?.ok && result.data?.data) {
			hasUnread.set(!!result.data.data.has_unread);
		}
	} finally {
		inflight = null;
	}
}
